import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { DocumentsCard, MobileCard } from './style';
import { downloadResource } from '../../../../utils/fileDownload';
import { FileImg } from '../../../../app/pages/DocumentDetails/style';
import { getIconByExtension } from '../../../../utils/fileExtension';
import { formatFileSize } from '../../../../utils/formatFileSize';
import Text from '../../Text';
import MultiActions from '../../MultiActions';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { DOCUMENTS_EXPERT_DOCUMENT_DELETE } from '../../../../app/redux/actions/documentsExpert';
import { MODAL_OPEN } from '../../../../app/redux/actions';
import { ModalDocDLConfirmId } from '../../Modals/ModalDocDLConfirm';
import { getUrlWithToken } from '../../../../utils/common';
import { DOCUMENT_DELETE } from '../../../../app/redux/actions/documents';
import theme from '../../../theme';
import { BOOKMARK_SET } from '../../../../app/redux/actions/bookmarks';
import { useHighlightText } from '../../../../utils/highlight';
import HtmlRaw from '../../HtmlRaw';

const CardDocuments = ({
  mediaIsPhone,
  isExpertDocument,
  item,
  onClick,
  className,
  deleteDocument,
  deleteDocumentExpert,
  handleGetDocuments,
  isSupervisor,
  isSubjectExpert,
  modalOpen,
  setBookmark,
}) => {
  const highlightText = useHighlightText;
  const [file, setFile] = useState();
  const [isBookmark, setIsBookmark] = useState(item?.bookmarked);

  useEffect(() => {
    if (item?.file) setFile(item.file);
  }, [item]);

  const handleOnclickBookmark = (e) => {
    setBookmark({ id: item?.id, action: !isBookmark });
    setIsBookmark(!isBookmark);
  };

  const getActionsOpts = () => {
    const actionOpts = [
      {
        label: 'Dettaglio documento',
        icon: 'message-smile-circle',
        onClick,
      },
      {
        label: 'Download',
        icon: 'download-01',
        onClick: () => {
          isSubjectExpert
            ? modalOpen(ModalDocDLConfirmId, {
                onClickAlt: () =>
                  downloadResource(getUrlWithToken(file?.url), file?.filename),
              })
            : downloadResource(getUrlWithToken(file?.url), file?.filename);
        },
      },
    ];

    if (!isExpertDocument) {
      actionOpts.unshift({
        label: isBookmark ? 'Rimuovi' : 'Preferiti',
        icon: 'star-01',
        onClick: () => handleOnclickBookmark(),
        fill: isBookmark ? theme().colors.link : 'none',
      });
    }

    if (isSupervisor) {
      actionOpts.push({
        label: item?.published ? 'Elimina' : 'Ripristina',
        icon: item?.published ? 'trash-01' : 'flip-backward',
        onClick: () =>
          isExpertDocument
            ? deleteDocumentExpert({
                id: item?.id,
                callback: handleGetDocuments,
                published: item?.published ? 0 : 1,
              })
            : deleteDocument({
                id: item?.id,
                callback: handleGetDocuments,
                published: item?.published ? 0 : 1,
              }),
      });
    }

    return actionOpts;
  };

  if (mediaIsPhone) {
    return (
      <MobileCard className={className}>
        <div />
        <MultiActions actions={getActionsOpts()} />
        <h5>Nome</h5>
        <Text type="h3" onClick={onClick} className="title">
          <HtmlRaw html={highlightText(item?.title)} />
        </Text>
        <h5>Formato</h5>{' '}
        <div className="file-icon">
          <FileImg src={getIconByExtension(file?.extension)} />
        </div>
        <h5>Tipologia</h5>
        <Text type="b4" className="ellipsis">
          {!(item?.document_typology?.length > 0) && '-'}
          {(item?.document_typology || []).map((t, i) => (
            <span key={`typology-${i}`}>
              {i > 0 && <span> - </span>}
              {t?.name}
            </span>
          ))}
          <span /> {/* MISTERY: needed to render the upper typologies... */}
        </Text>
        {isSupervisor && isExpertDocument && (
          <>
            <h5>Visibilità</h5>
            <Text type="b4">
              {item?.published ? 'Visibile' : 'Non visibile'}
            </Text>
          </>
        )}
        <h5>Data</h5>
        <Text type="b5" className="date" color="#515151">
          {dayjs((item?.created || 0) * 1000).format('DD/MM/YYYY')}
        </Text>
        <h5>Dimensione</h5>
        <Text type="b5" className="size" color="#8B8B8B">
          {formatFileSize(file?.size)}
        </Text>
      </MobileCard>
    );
  }

  return (
    <DocumentsCard className={className}>
      <div className="file-icon">
        <FileImg src={getIconByExtension(file?.extension)} />
      </div>
      <Text type="h3" onClick={onClick} className="title">
        <HtmlRaw html={highlightText(item?.title)} />
      </Text>
      <Text type="b4" className="ellipsis">
        {!(item?.document_typology?.length > 0) && '-'}
        {(item?.document_typology || []).map((t, i) => (
          <span key={`typology-${i}`}>
            {i > 0 && <span> - </span>}
            {t?.name}
          </span>
        ))}
        <span /> {/* MISTERY: needed to render the upper typologies... */}
      </Text>
      {isSupervisor && isExpertDocument && (
        <Text type="b4">{item?.published ? 'Visibile' : 'Non visibile'}</Text>
      )}
      <Text type="b5" className="date" color="#515151">
        {dayjs((item?.created || 0) * 1000).format('DD/MM/YYYY')}
      </Text>
      <Text type="b5" className="size" color="#8B8B8B">
        {formatFileSize(file?.size)}
      </Text>
      <MultiActions actions={getActionsOpts()} />
    </DocumentsCard>
  );
};

CardDocuments.propTypes = {
  mediaIsPhone: PropTypes.bool,
  item: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
  handleGetDocuments: PropTypes.func,
  isExpertDocument: PropTypes.bool,
  // HOC (connect, state)
  isSupervisor: PropTypes.bool,
  isSubjectExpert: PropTypes.bool,
  // HOC (connect, dispatch)
  deleteDocument: PropTypes.func.isRequired,
  deleteDocumentExpert: PropTypes.func.isRequired,
  setBookmark: PropTypes.func.isRequired,
  modalOpen: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { isSupervisor, isSubjectExpert } = state.user;

      return {
        isSupervisor,
        isSubjectExpert,
      };
    },
    (dispatch) => ({
      deleteDocumentExpert: ({ id, callback, published }) =>
        dispatch({
          type: DOCUMENTS_EXPERT_DOCUMENT_DELETE._REQUEST,
          id,
          callback,
          published,
        }),
      deleteDocument: ({ id, callback, published }) =>
        dispatch({
          type: DOCUMENT_DELETE._REQUEST,
          id,
          callback,
          published,
        }),
      setBookmark: ({ id, action }) =>
        dispatch({
          type: BOOKMARK_SET._REQUEST,
          id,
          action,
          item_type: 'document',
        }),
      modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
    })
  ),
  withMediaQueries
)(CardDocuments);
